<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div *ngIf="isLoading" class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div
      *ngIf="resetComplete"
      class="card-footer alert alert-success col-12 col-xs-9 col-lg-8"
    >
      {{ globalService.Get("RESET_SUCCESSFUL") }}
      <a
        href="https://{{ tenantSubdomain }}.{{ getDomain() }}.org/"
        >{{ globalService.Get("RESET_SUCCESSFUL_LINK") }}</a
      >
      {{ globalService.Get("RESET_SUCCESSFUL_SUFFIX") }}
    </div>
    <div class="card SmallForm rounded" *ngIf="!isLoading && !resetComplete">
      <div class="card-header MyCardHeader rounded-top">
        <h2>{{ globalService.Get("UPDATE_PASSWORD") }}</h2> 
      </div>
      <div class="card-body MyCardBody rounded-bottom">
        <div class="card-footer MyError" role="alert" *ngIf="error">
          <p>{{ error }}</p>
        </div>
        <form
          *ngIf="resetForm"
          [formGroup]="resetForm"
          (ngSubmit)="onSubmit()"
          autocomplete="off"
          name="dummy"
        >
          <div class="form-group row m-3">
            <label for="password">{{ globalService.Get("PASSWORD") }}</label>
            <input
              type="password"
              id="password"
              class="form-control"
              formControlName="password"
              autocomplete="new-password"
            />
            <small
              class="help-block"
              *ngIf="
                !resetForm.get('password').valid &&
                (resetForm.get('password').touched || submit)
              "
              >{{ globalService.Get("VALIDPASSWORD") }}</small
            >
          </div>
          <div class="form-group row m-3">
            <label for="confirmPassword">{{
              globalService.Get("CONFIRM_PASSWORD")
            }}</label>
            <input
              type="password"
              id="confirmPassword"
              class="form-control"
              formControlName="confirmPassword"
            />
            <small
              class="help-block"
              *ngIf="
                resetForm.errors?.passwordMismatch &&
                (resetForm.get('confirmPassword').touched || submit) &&
                (resetForm.get('password').touched || submit)
              "
              >{{ globalService.Get("PASSWORD_MISMATCH") }}</small
            >
          </div>
          <div class="row VerticalMargin">
            <button
              class="btn btn btn-primary m-auto"
              type="submitReactiveFormsModule"
            >
              {{ globalService.Get("SAVE_PASSWORD") }}
            </button>
          </div>
        </form>
        <div
          *ngIf="
            resetForm.get('password').errors &&
            resetForm.get('password').touched
          "
          class="card-footer alert alert-primary"
        >
          {{ globalService.Get("PASSWORD_RESTRICTIONS") }}
        </div>
      </div>
    </div>
  </div>
</div>
